<template>
  <div>
    <div class="aws-sku-descriptions">
      <div class="aws-sku-descriptions-image">
        <el-image :src="displayImage" :preview-src-list="imageList" />
      </div>

      <div class="aws-sku-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">物料编号</div>
              <div class="descriptions-content">
                {{ data.skuMaterialNo }}
              </div>
            </el-col>
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">物料类型</div>
              <div class="descriptions-content">
                {{ data.materialCategoryName }}
              </div>
            </el-col>
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">所属品牌</div>
              <div class="descriptions-content">
                {{ data.brandName }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="13" class="descriptions-item">
              <div class="descriptions-label">物料名称</div>
              <div class="descriptions-content">
                {{ data.materialName || '' }}
              </div>
            </el-col>
            <el-col :span="11" class="descriptions-item">
              <div class="descriptions-label">英文名称</div>
              <div class="descriptions-content">
                {{ data.materialNameEn || '' }}
              </div>
            </el-col>
          </el-row>
          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div class="descriptions-label">材质</div>
              <div class="descriptions-content">
                {{ data.materialDesc || '' }}
              </div>
            </el-col>
          </el-row>
          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div class="descriptions-label">规格尺寸</div>
              <div class="descriptions-content">
                {{ data.materialSpec || '' }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">指定供应商</div>
              <div class="descriptions-content">
                {{
                  data.isSpecify ? (data.isSpecify == 'Y' ? '是' : '否') : ''
                }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">供应商</div>
              <div class="descriptions-content">
                {{ data.scmName || '' }}
              </div>
            </el-col>
            <el-col :span="6" class="descriptions-item">
              <div class="descriptions-label">物料单位</div>
              <div class="descriptions-content">
                {{ data.v_materialUnit }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="aws-sku-descriptions">
      <div class="aws-sku-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div
                class="descriptions-label d-flex align-items-center"
                style="text-align: center;min-width: 120px;width: 120px;"
              >
                <div>
                  说明文件
                  <el-button
                    v-if="data.materialCode"
                    style="margin-top: 100px;"
                    plain
                    type="warning"
                    size="mini"
                    @click="editMaterialVisible = true"
                    >{{
                      $l('INDEX.material_btn_edit') || '编辑物料'
                    }}</el-button
                  >
                </div>
              </div>
              <div class="descriptions-content">
                <FileList
                  :items="data.docList || []"
                  :disabled="true"
                  :cols="3"
                  :layout="{ size: true, delete: true }"
                ></FileList>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <EditMaterial
      :title="$l('INDEX.material_edit_title') || '编辑物料信息'"
      :visible.sync="editMaterialVisible"
      :productLine="'ABSHome'"
      :materialCode="data.materialCode"
      :amzSkuCode="data.amzSkuCode"
      :amzSkuMaterialCode="data.amzSkuMaterialCode"
      :amzSkuMaterialGroup="data.amzSkuMaterialGroup"
      type="radio"
      @close="close"
    />
  </div>
</template>

<script>
import FileList from '@/views/ecom/components/file-list'
import EditMaterial from '../edit-material/drawer.vue'
export default {
  components: {
    FileList,
    EditMaterial,
  },
  props: { data: { type: Object, default: () => {} } },
  data() {
    return {
      editMaterialVisible: false,
    }
  },
  computed: {
    imageList() {
      const { imageList } = this.data
      return this.sortImageList(imageList || [])
    },
    displayImage() {
      if (this.imageList && this.imageList.length > 0) {
        return this.imageList[0] || '/image/static/img/nopic-square.jpg'
      }
      return '/image/static/img/nopic-square.jpg'
    },
  },
  methods: {
    sortImageList(sortedList) {
      if (!sortedList.length) return []
      return sortedList.map((item) => item.originImageUrl)
    },
    close() {
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-descriptions {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  .aws-sku-descriptions-image {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-right: none;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-image {
      width: 100px;
      height: 100px;
    }
  }

  .aws-sku-descriptions-info {
    flex-grow: 1;
  }
}

.descriptions {
  --padding: 10px 12px;

  --border-width: 1px;
  --border-style: solid;
  --border-color: #ebeef5;

  --label-width: 125px;
  --label-bg: #f5f7fa;

  border-width: var(--border-width);
  border-color: var(--border-color);
  border-left-style: var(--border-style);
  border-bottom-style: var(--border-style);

  .descriptions-row {
    display: flex;
    align-items: stretch;
    .descriptions-item {
      display: flex;
      align-items: stretch;
      flex-direction: row;
      .descriptions-label {
        font-size: 14px;
        color: #909399;
        width: var(--label-width);
        min-width: var(--label-width);
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        background-color: var(--label-bg);
      }

      .descriptions-content {
        flex-grow: 1;
        font-size: 14px;
        color: #606266;
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        word-break: break-all;
      }
    }
  }
}
</style>
